import { QuestionTypeId } from './instrument.interface'

import type { IEntry} from './instrument.interface';
import type { QuestionId } from './types'

export function newEntry(visit: IEntry, instrumentId: string) {
  return {
    id: '89f97ef3-a74a-43a2-9c29-072c90fbff00',
    visitId: visit.visitId,
    instrumentId: instrumentId,
    responses: {},
  }
}

export function displayLabelIfExists({
  label,
  id,
}: {
  label?: string
  id: string
}) {
  return label ?? id
}

export const questions = {
  binary(
    questionId: QuestionId,
    label: string,
    details: string,
    required: boolean,
    options: Record<string, string>,
  ) {
    return {
      questionId,
      inputType: QuestionTypeId.Binary,
      details,
      label,
      required,
      options,
    }
  },
  checkbox(
    questionId: QuestionId,
    label: string,
    details: string,
    required: boolean,
    options: Record<string, string>,
  ) {
    return {
      questionId,
      inputType: QuestionTypeId.Checkbox,
      label,
      details,
      required,
      options,
    }
  },
  date(
    questionId: QuestionId,
    label: string,
    details: string,
    required: boolean,
  ) {
    return {
      questionId,
      inputType: QuestionTypeId.Date,
      label,
      details,
      required,
    }
  },
  radio(
    questionId: QuestionId,
    label: string,
    details: string,
    required: boolean,
    options: Record<string, string>,
  ) {
    return {
      questionId,
      inputType: QuestionTypeId.Radio,
      label,
      details,
      required,
      options,
    }
  },
  text(
    questionId: QuestionId,
    label: string,
    details: string,
    required: boolean,
  ) {
    return {
      questionId,
      inputType: QuestionTypeId.Text,
      label,
      details,
      required,
    }
  },
}
